import {initial} from './loading-state';
import constants from '../utils/constants';

const sortByUpdateTime = ((a, b) => {
    const aDate = new Date(a.updateTime);
    const bDate = new Date(b.updateTime);
    return (aDate < bDate) - (aDate > bDate); // trick for turning booleans into 1, 0, -1 range
});

// returns boards sorted by updateTime with listings sorted by updateTime
function getTripboardsByUpdateTime(state) {
    return Object.values(state.tripboard.tripboards)
        .sort(sortByUpdateTime)
        .reduce((boards, board) => {
            if (board.role.toLowerCase() !== constants.VIEWER) {
                const listings = Object.values(board.listings).sort(sortByUpdateTime);
                return boards.concat({
                    ...board,
                    listings
                });
            }
            return boards;
        }, []);
}

function getTripboard(state, props) {
    const board = state.tripboard.tripboards[props.match.params.boardId];
    if (!board) {
        return board;
    }
    return {
        ...board,
        isFavorite: board.sourceFavorite,
        isShared: board.shared,
        listings: Object.values(board.listings).sort(sortByUpdateTime)
    };
}

function getCurrentBoardId(state) {
    const boardId = state.tripboard.currentTripboard.currentBoardId;
    if (!boardId) {
        return '';
    }
    return boardId;
}

function getPreviewsLoadingState(state) {
    return state.tripboard.previewsLoadingState;
}

function getDetailsLoadingState(state, props) {
    const loadingState = state.tripboard.detailsLoadingState[props.match.params.boardId];
    return (!loadingState)
        ? initial
        : loadingState;
}

function getInvitation(state) {
    return state.tripboard.invitation;
}

export {
    getTripboardsByUpdateTime,
    getTripboard,
    getPreviewsLoadingState,
    getDetailsLoadingState,
    getCurrentBoardId,
    getInvitation
};



// WEBPACK FOOTER //
// ./src/universal/tripboard/selectors.js